module.exports = __webpack_public_path__ + "img/9-8.ef2aa496.png";